import { mdlReservation } from "../models/domain/Reservation";
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlBaseIdRequest } from "../models/service-models/common/BaseIdRequest";
import { mdlBaseSuccessfullResponse } from "../models/service-models/common/BaseSuccessfullResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlReservationConfirmRequest } from "../models/service-models/reservation/ReservationConfirmRequest";
import { mdlReservationConfirmResponse } from "../models/service-models/reservation/ReservationConfirmResponse";
import mdlReservationCustomerDetailRequest from "../models/service-models/reservation/ReservationCustomerDetailRequest";
import { mdlReservationCustomerDetailResponse } from "../models/service-models/reservation/ReservationCustomerDetailResponse";
import { mdlReservationDetailRequest } from "../models/service-models/reservation/ReservationDetailRequest";
import { mdlReservationDetailResponse } from "../models/service-models/reservation/ReservationDetailResponse";
import { mdlReservationDetailsRequest } from "../models/service-models/reservation/ReservationDetailsRequest";
import { mdlReservationDetailsResponse } from "../models/service-models/reservation/ReservationDetailsResponse";
import { mdlReservationValidateDisplayRequest } from "../models/service-models/reservation/ReservationDisplayValidateRequest";
import { mdlReservationFilterSaveRequest } from "../models/service-models/reservation/ReservationFilterSaveRequest";
import { mdlReservationHistoryDetailRequest } from "../models/service-models/reservation/ReservationHistoryDetailRequest";
import { mdlReservationHistoryDetailResponse } from "../models/service-models/reservation/ReservationHistoryDetailResponse";
import { mdlReservationListRequest } from "../models/service-models/reservation/ReservationListRequest";
import { mdlReservationListResponse } from "../models/service-models/reservation/ReservationListResponse";
import { mdlReservationRejectRequest } from "../models/service-models/reservation/ReservationRejectRequest";
import { mdlReservationRejectResponse } from "../models/service-models/reservation/ReservationRejectResponse";
import { mdlReservationSendMailRequest } from "../models/service-models/reservation/ReservationSendMailRequest";
import { mdlReservationSendMailResponse } from "../models/service-models/reservation/ReservationSendMailResponse";
import { mdlReservationUserFilterListResponse } from "../models/service-models/reservation/ReservationUserFilterListResponse";
import { mdlReservationUserFilterListRequest } from "../models/service-models/reservation/ReservationUserFilterRequest";
import { GetResponse } from "../utils/ApiClient";

namespace ReservationService {
    export async function SaveFilter(
        pRequest: mdlReservationFilterSaveRequest
    ): Promise<mdlServiceResponse<mdlBaseSuccessfullResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseSuccessfullResponse>>(
            "reservation/save-filter",
            pRequest
        );
    }

    export async function RemoveFilter(
        pRequest: mdlBaseIdRequest
    ): Promise<mdlServiceResponse<mdlBaseSuccessfullResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseSuccessfullResponse>>(
            "reservation/remove-filter",
            pRequest
        );
    }

    export async function GetFilters(
        pRequest: mdlReservationUserFilterListRequest
    ): Promise<mdlServiceResponse<mdlReservationUserFilterListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationUserFilterListResponse>>(
            "reservation/get-filters",
            pRequest
        );
    }

    export async function List(
        pRequest: mdlReservationListRequest
    ): Promise<mdlServiceResponse<mdlReservationListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationListResponse>>(
            "reservation/list",
            pRequest
        );
    }


    export async function Customers(
        pRequest: mdlReservationCustomerDetailRequest
    ): Promise<mdlServiceResponse<mdlReservationCustomerDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationCustomerDetailResponse>>(
            "reservation/customers",
            pRequest
        );
    }

    export async function Detail(
        pRequest: mdlReservationDetailRequest
    ): Promise<mdlServiceResponse<mdlReservationDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationDetailResponse>>(
            "reservation/detail",
            pRequest
        );
    }

    export async function MultiDetail(
        pRequest: mdlReservationDetailsRequest
    ): Promise<mdlServiceResponse<mdlReservationDetailsResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationDetailsResponse>>(
            "reservation/multi-detail",
            pRequest
        );
    }

    export async function Confirm(
        pRequest: mdlReservationConfirmRequest
    ): Promise<mdlServiceResponse<mdlReservationConfirmResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationConfirmResponse>>(
            "reservation/confirm",
            pRequest
        );
    }

    export async function Reject(
        pRequest: mdlReservationRejectRequest
    ): Promise<mdlServiceResponse<mdlReservationRejectResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationRejectResponse>>(
            "reservation/reject",
            pRequest
        );
    }

    export async function SendMail(
        pRequest: mdlReservationSendMailRequest
    ): Promise<mdlServiceResponse<mdlReservationSendMailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationSendMailResponse>>(
            "reservation/send-mail",
            pRequest
        );
    }

    export async function ResDisplayValidate(
        pRequest: mdlReservationValidateDisplayRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<mdlReservation>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<mdlReservation>>>(
            "reservation/res-display-validation",
            pRequest
        );
    }

    export async function History(
        pRequest: mdlReservationHistoryDetailRequest
    ): Promise<mdlServiceResponse<mdlReservationHistoryDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlReservationHistoryDetailResponse>>(
            "reservation/history",
            pRequest
        );
    }
}
export { ReservationService };
